import { hasRole, type Role } from '@conversia/shared-types';

/**
 * Qué puede ver cada rol en "Agentes AI". PURO.
 *
 * La pantalla está en el menú de la oficina (AGENT), pero el costo del mes es
 * del DUEÑO y los asistentes automáticos son de ADMIN: pedirlos igual devolvía
 * 403 y dejaba errores en la consola. Mismo criterio que el menú: sin rol
 * resuelto todavía, no se pide nada.
 */
export function permisosDeAgentes(rol: Role | undefined): {
  verCostos: boolean;
  verAsistentesAutomaticos: boolean;
} {
  return {
    verCostos: rol === 'OWNER',
    verAsistentesAutomaticos: Boolean(rol && hasRole(rol, 'ADMIN')),
  };
}
